const pt_PT = {

            'title':"Sistema de Verificação das Habilitações Académicas",
			'preMessage':"Bem-vindo ao Sistema de Verificação das Habilitações Académicas do UPM! Para realização da verificação, por favor, preencha as informações constantes do Certificado/ Carta de Curso. Para qualquer situação especial, contacte com a Divisão de Admissão, Matrícula e Inscrição (DAMIA) por email (Email: registry@mpu.edu.mo; Tel: +853-8599 6111/6103).",
            'form.studName' :"Nome do Aluno",
            'form.dob' :"Data de Nascimento (YYYY/MM/DD)",
            'form.studName.placeholder' :" ",
            'form.studName.hints' :"",
            'form.dob.placeholder' :"YYYY/MM/DD",
            'form.status':"Tipo de Documento",
            'form.status.current':"Certificado",
            'form.status.graduate':"Carta de curso",
            'form.gradYear':"Ano de Graduação (YYYY)",
            'form.gradYear.placeholder':"YYYY",
            'form.qual':"Habilitação académica",
            'form.qual.a':"A",
            'form.qual.b':"B",
            'form.qual.c':"C",
            'form.prog':"Nome do Curso",
            'form.certNo':"Número do certificado/ carta de curso",
            'form.submit':"Verificar novamente",
            'form.modify':"Editar",
            'form.reset':"Reset",
            'form.hints':"*Preencha todos os espaços vagos",
            'result.title':"Resultado",
            'result.success':"Confirma-se que as informações preenchidas são consistentes com o registado no sistema.",
            'result.fail':"Confirma-se que as informações preenchidas são inconsistentes com o registado no sistema. Por favor, preencha novamente ou contacte com a DAMIA.",
            'server.error':"Ocorreu um erro. Atualize a página e tente novamente.",
            'form.error.required':"Campo de preenchimento obrigatório.",
            'form.error.isDate':"Por favor, introduza uma data válida.",
            'form.error.radio.required':"Campo de preenchimento obrigatório."
        }
export default pt_PT;


// WEBPACK FOOTER //
// ./src/i18n/pt_PT.js